import ActionName from '@/enums/action-name';
import Role from '@/enums/role';
import RouteName from '@/enums/route-name';
import { RoleProtectedFeature } from '@/types/feature-names';

const REQUIRED_ROLES: Record<RoleProtectedFeature, Role[]> = {
    [RouteName.CREATE_SHIPMENT]: [
        Role.GLS_ADMIN,
        Role.PARTNER_CREATOR,
        Role.PARTNER_OPERATOR,
        Role.CUSTOMER_FRONTEND,
        Role.CREATE_SHIPMENT
    ],
    [RouteName.SHIPMENT_ORDER]: [Role.GLS_ADMIN],
    [RouteName.PARCEL_DATA]: [Role.GLS_ADMIN, Role.PARCEL_DATA, Role.PARTNER_CUSTOMER_SERVICE],
    [RouteName.PARCEL_TRACKING]: [Role.GLS_ADMIN, Role.PARCEL_TRACKING, Role.PARTNER_CUSTOMER_SERVICE],
    [RouteName.REVERT]: [Role.GLS_ADMIN, Role.PARTNER_OPERATOR, Role.REVERT_PARCEL],
    [RouteName.REPRINT]: [Role.GLS_ADMIN, Role.PARTNER_OPERATOR, Role.REPRINT_LABEL],
    [RouteName.FORWARD]: [Role.GLS_ADMIN, Role.PARTNER_OPERATOR, Role.FORWARD_PARCEL],
    [RouteName.INITIAL]: [Role.GLS_ADMIN, Role.PARTNER_OPERATOR, Role.INITIAL_PARCEL],
    [RouteName.SHIPMENT_OVERVIEW]: [
        Role.GLS_ADMIN,
        Role.CUSTOMER_FRONTEND,
        Role.PARTNER_OPERATOR,
        Role.PARTNER_CREATOR,
        Role.SHIPMENT_OVERVIEW
    ],
    [RouteName.TRANSPORTATION_LIST_CREATE]: [Role.GLS_ADMIN, Role.CREATE_TRANSPORTATION_LIST],
    [RouteName.TRANSPORTATION_OVERVIEW]: [Role.GLS_ADMIN, Role.TRANSPORTATION_OVERVIEW],
    [RouteName.PARCEL_AUTO_ASSIGNMENT]: [Role.GLS_ADMIN, Role.PARTNER_OPERATOR, Role.AUTO_PARCELS_ASSIGNMENT],
    [RouteName.ASSIGN_PARCELS_TO_LOADING_LIST]: [Role.GLS_ADMIN, Role.PARTNER_OPERATOR, Role.LOADING_LIST_ASSIGNMENT],
    [RouteName.PARCEL_STATUS_ASSIGNMENT]: [Role.GLS_ADMIN, Role.PARTNER_CUSTOMER_SERVICE, Role.PARTNER_OPERATOR, Role.PARTNER_CREATOR],
    [RouteName.MT_WEIGHING_SCALE_TESTING]: [], // TODO to be removed
    [ActionName.TRANSPORTATION_STATUS_UPDATE]: [Role.GLS_ADMIN, Role.TRANSPORTATION_OVERVIEW],
    [ActionName.TRANSPORTATION_PARCELS_PREVIEW]: [Role.GLS_ADMIN, Role.TRANSPORTATION_OVERVIEW],
    [ActionName.TRANSPORTATION_LOAD_UNITS_PREVIEW]: [Role.GLS_ADMIN, Role.TRANSPORTATION_OVERVIEW],
    [ActionName.PARCEL_TRACKING_INPUT]: [Role.GLS_ADMIN, Role.PARTNER_CUSTOMER_SERVICE, Role.PARTNER_OPERATOR, Role.PARTNER_CREATOR]
};

export default REQUIRED_ROLES;
